/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementMediumFilterRequest { 
    name?: string;
    types?: Array<ManagementMediumFilterRequest.TypesEnum>;
    langs?: Array<ManagementMediumFilterRequest.LangsEnum>;
}
export namespace ManagementMediumFilterRequest {
    export type TypesEnum = 'PRINTED' | 'WEB' | 'TV' | 'RADIO' | 'SOCIAL';
    export const TypesEnum = {
        PRINTED: 'PRINTED' as TypesEnum,
        WEB: 'WEB' as TypesEnum,
        TV: 'TV' as TypesEnum,
        RADIO: 'RADIO' as TypesEnum,
        SOCIAL: 'SOCIAL' as TypesEnum
    };
    export type LangsEnum = 'MK' | 'EN' | 'AL';
    export const LangsEnum = {
        MK: 'MK' as LangsEnum,
        EN: 'EN' as LangsEnum,
        AL: 'AL' as LangsEnum
    };
}